exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-qa-slide{margin-bottom:20px}.sub-qa-slide .text-wrap{padding:15px 20px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-751c3993","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Qna/notice.vue
// module id = 156
// module chunks = 0